import React from 'react'
import { useQueryPaginator } from 'src/components/Table'
import { skuit } from 'src/services/skuit'

import { DamagedListTable } from 'src/components/Table/list/Damaged'
import { ListPage } from 'src/components/Pages/ListPage'

export const DamagedListPage = () => {
  const paginator = useQueryPaginator('damaged-list', skuit.client.damaged.list)

  const exportFields = [
    "asn_guid",
    "asn_tracking_number",
    "damage_reason",
    "damaged_on",
    "facility",
    "facility_guid",
    "guid",
    "notes",
    "product_guid",
    "product_name",
    "sku",
    "sku_guid",
    "by_us",
  ]

  return (
    <ListPage
      title='Damages'
      paginator={paginator}
    >
      <DamagedListTable
        paginator={paginator}
        fields={['guid', 'sku', 'batch', 'damage', 'damagedOn', 'byUs', 'notes']}
        exportConfig={{
          exportFields: exportFields,
          exportAPI: skuit.client.damaged.export,
        }}
      />
    </ListPage>
  )
}
